import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "drv-form-root" }
const _hoisted_2 = { key: 0 }

import { computed, ref } from "vue";
import {
  ETelematicsMessagesKeys,
  IPlatform,
  EPlatformName,
  IBaseEmail,
  EAuthTypes,
} from "../../../../types";
import { Input } from "draivn-ui-kit/components/input";
import { emailValidator, requiredValidator } from "draivn-ui-domain";
import { EMessagesKeys } from "@/modules/help-center";


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseEmail',
  props: {
    modelValue: {},
    platform: {},
    disable: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const EMPTY_MODEL: IBaseEmail = {
  type: EAuthTypes.ACCOUNT,
  email: "",
};

const model = computed<IBaseEmail>({
  get() {
    return props.modelValue ?? EMPTY_MODEL;
  },
  set(value: IBaseEmail) {
    emit("update:modelValue", value);
  },
});

const email = computed<string>({
  get() {
    return props.modelValue?.email ?? EMPTY_MODEL.email;
  },
  set(value: string) {
    model.value = { ...model.value, email: value };
  },
});

const textByPlatformName: Partial<
  Record<EPlatformName, { snackbarText: string; fieldTitle: string }>
> = {
  [EPlatformName.FLEETLOCATE_SPIREON_NSPIRE]: {
    snackbarText: ETelematicsMessagesKeys.FLEET_LOCATE_SPIREON_DESCRIPTION,
    fieldTitle: ETelematicsMessagesKeys.FLEET_LOCATE_SPIREON_EMAIL_TITLE,
  },
};

const currentText = computed<{
  snackbarText: string;
  fieldTitle: string;
}>(() => {
  return (
    textByPlatformName[props.platform.const] ?? {
      snackbarText: "",
      fieldTitle: "Email",
    }
  );
});

const emailControl = ref<typeof Input | null>(null);
const hasError = computed<boolean>(() => {
  return !email.value || emailControl.value?.hasError;
});

__expose({
  hasError,
});

return (_ctx: any,_cache: any) => {
  const _component_d_snackbar = _resolveComponent("d-snackbar")!
  const _component_d_input = _resolveComponent("d-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (currentText.value.snackbarText?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_d_snackbar, {
            icon: "triangle-exclamation",
            class: "drv-bg-color-b100 drv-color-b600 drv-my-2",
            message: _ctx.$t(currentText.value.snackbarText)
          }, null, 8, ["message"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_d_input, {
      ref_key: "emailControl",
      ref: emailControl,
      modelValue: email.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
      disable: _ctx.disable,
      class: "drv-form-control-adaptive drv-my-2",
      label: _ctx.$t(currentText.value.fieldTitle),
      "lazy-rules": "",
      "label-slot": "",
      rules: [
        _unref(requiredValidator)(_ctx.$t(_unref(EMessagesKeys).VALIDATORS_REQUIRED_COMMON_MESSAGE)),
        _unref(emailValidator)(_ctx.$t(_unref(EMessagesKeys).VALIDATORS_EMAIL_COMMON_MESSAGE)),
      ]
    }, null, 8, ["modelValue", "disable", "label", "rules"])
  ]))
}
}

})